import { render } from "./MohReports.vue?vue&type=template&id=537698a6&scoped=true"
import script from "./MohReports.vue?vue&type=script&lang=js"
export * from "./MohReports.vue?vue&type=script&lang=js"

import "./MohReports.vue?vue&type=style&index=0&id=537698a6&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/HMS-MAIN/PORTAL/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-537698a6"]])

export default __exports__